import { gql, useLazyQuery } from "@apollo/client";

const GET_VERIFY_TOKEN_FOR_MEDICAL_FORM_PDF=gql`
query GetVerifyTokenForMedicalFormPdfDownload($clientId: Int, $token: String) {
    getVerifyTokenForMedicalFormPdfDownload(clientId: $clientId, token: $token) {
      success
      message
      data {
        medicalFormPdfBase64
        pdfUrl
      }
    }
  }
`;

export const GetVerifyTokenForMedicalFormPdfDownloadAction=()=>{
    const [
        getVerifyTokenForMedicalFormPdfResponseFunction,
        getverifyTokenForMedicalFormPdfResponseData
    ]=useLazyQuery(GET_VERIFY_TOKEN_FOR_MEDICAL_FORM_PDF,{
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-and-network",
        onCompleted:({getVerifyTokenForMedicalFormPdfDownload:responseData})=>{
            if(responseData.success){

            }
        }
    })

    const getVerifyTokenForMedicalFormPdfQueryData=getverifyTokenForMedicalFormPdfResponseData

    const initGetVerifyTokenForMedicalformPdfData=(data, successCallback, errorCallback)=>{
      getVerifyTokenForMedicalFormPdfResponseFunction({
        variables:data
      }).then((res)=>{
            successCallback(res)
      }).catch((error)=>{
            errorCallback(error)
      })
    }

    return {initGetVerifyTokenForMedicalformPdfData,getVerifyTokenForMedicalFormPdfQueryData}
}
